import { Reference } from 'common/reference/reference.js';
import { SummaryItem } from 'components.modules.gen/category-summary/item.js';
import { StatusRating } from 'utilities/status/status-rating.js';
import { IntegrationsConditionsType } from './types.js';

export enum DryingIndexColorState {
  'green' = 'green',
  'red' = 'red',
}

export type DryingIndexProps = IntegrationsConditionsType<{
  dryingState: {
    text: string;
    state: StatusRating | DryingIndexColorState;
    emojiHex?: string;
  }[];
}>;

const getNewStatus = (color: StatusRating | DryingIndexColorState): StatusRating => {
  if (color === DryingIndexColorState.green) {
    return StatusRating.statusGood;
  }
  if (color === DryingIndexColorState.red) {
    return StatusRating.statusBad;
  }
  return color;
};

export const DryingIndex = ({ dryingIndex }: { dryingIndex?: DryingIndexProps }) => {
  if (dryingIndex) {
    const { dryingState, tagline, sponsorImage, sponsorURL, displayEndOfSeasonMessage, endOfSeasonMessage } =
      dryingIndex;

    if (displayEndOfSeasonMessage) {
      if (endOfSeasonMessage) {
        return <SummaryItem icon={'washing'} dataModule={'dryingIndex-content'} content={[endOfSeasonMessage]} />;
      }
      return null;
    } else {
      if (dryingState) {
        const normalisedState = dryingState.map((ds) => {
          const state = getNewStatus(ds.state);
          return {
            text: ds.text,
            state,
          };
        });

        return (
          <SummaryItem
            icon={'washing'}
            dataModule={'dryingIndex-content'}
            title="Laundry Drying Time"
            subTitle={normalisedState}
          >
            <Reference image={sponsorImage} text={tagline} url={sponsorURL} classes="u-mT-xs u-mB-xs" />
          </SummaryItem>
        );
      }
      return null;
    }
  }

  return null;
};
